import React from 'react';
import DomainActions from './domainActions';
import DomainNameCell from './domainNameCell';
import DnsDomainCell from './dnsDomainCell';

export const formatName = (id) => {

    return <DomainNameCell id={id} />;
};

export const formatDns = (id) => {

    return <DnsDomainCell id={id} />;
};

export const formatDomainActions = (id) => {

    return <DomainActions id={id} />;
};

